import { Stream } from "./Stream";
import { Channel } from "./type";
import { Observable, BehaviorSubject } from "rxjs";

export class Client {
  static channels: Array<Channel> = [];
  static stream: Stream | null;

  static async connect(env = {}): Promise<Stream> {
    if (Client.stream) return Client.stream;
    Client.stream = new Stream(env);
    Client.stream.message((data) => Client.message(data));
    await Client.stream.connect();
    return Client.stream;
  }

  static listen(channel: string): Observable<any> {
    if (!Client.stream) throw new Error("Stream not connected");
    if (!Client.has(channel)) {
      Client.add({ channel, observable: new BehaviorSubject(null) });
    }

    return Client.get(channel).observable;
  }

  static get(channel: string): Channel {
    if (!Client.has(channel)) {
      Client.add({ channel, observable: new BehaviorSubject(null) });
    }

    for (const key in Client.channels) {
      if (Client.channels[key].channel == channel) {
        return Client.channels[key];
      }
    }

    throw new Error("Channel did not exist");
  }

  static message(data: any) {
    const name = data.channel;
    const channel: Channel = Client.get(name);
    channel.observable.next(data.message);
  }

  static add({ channel, observable }: Channel) {
    if (Client.has(channel)) return;

    Client.stream?.register(channel);
    Client.channels.push({ channel, observable });
  }

  static all() {
    return Client.channels;
  }

  static has(channel) {
    for (const key in Client.channels) {
      if (Client.channels[key].channel == channel) {
        return true;
      }
    }
    return false;
  }

  static disconnect() {
    if (!Client.stream) return;

    Client.stream.disconnect();
    Client.stream = null;
    Client.channels = [];
  }
}
